// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__wQ4UPTbr","warning":"SignUpIncorrectBirthStep_warning__VnxWSiMg","back":"SignUpIncorrectBirthStep_back__c88XaZK2"};